import React, { Component } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import autobind from 'class-autobind';

import FittedImage from 'zoomforth_codesbane_viewer/component_lib/fitted_image.jsx';

class GridTileInnerTypeWebPreview extends Component {
  
  constructor(props){
    super(props);
    
    autobind(this);
  }

  render() {
    const style = {};
    const textStyle = {};

    const {
      linkHasNoImage,
      linkTitle,
      linkSource,
      linkDescription,
      horizontalAlign,
      linkImageUrl,
      innerTileStyle,
      zfImage,
      altText
    } = this.props;

    if (horizontalAlign) {
      style['textAlign'] = horizontalAlign;
    }

    const { backgroundColor, color } = innerTileStyle;

    if (backgroundColor) {
      style['backgroundColor'] = backgroundColor;
    }

    if (color) {
      textStyle['color'] = color;
    }
    
    return (
      <div 
        className={classNames('tile-link', { 'no-image':linkHasNoImage })}
        style={style}
      >
        
        <FittedImage 
          zfImage={zfImage}
          className="link-image-container"
          altText={altText}
          src={linkImageUrl}
        />
        <div className="link-meta-container">
          <div className="link-title" style={textStyle}>
            {linkTitle}
          </div>
          <div className="link-source" style={textStyle}>
            {linkSource}
          </div>
          <div className="link-description" style={textStyle}>
            {linkDescription}
          </div>
        </div>
      </div>
    );
  }

}


GridTileInnerTypeWebPreview.propTypes = {
  linkImageUrl: PropTypes.string,
  linkTitle: PropTypes.string,
  linkHasNoImage: PropTypes.bool,
  linkSource: PropTypes.string,
  linkDescription: PropTypes.string,
  horizontalAlign: PropTypes.string
};

export default GridTileInnerTypeWebPreview;
